import React from 'react';
import { Container } from './styles';

const NetMetering = () => (
    <Container>
        <div className="col span1-of-1 diagramNetMetering" />
    </Container>
);

export default NetMetering;



// WEBPACK FOOTER //
// ./src/containers/Home/NetMetering/NetMetering.js